<template>
  <div class="addDialog">
    <el-form
      size="mini"
      :model="listingForm"
      label-width="75px"
      ref="listingForm"
      :rules="rules"
      class="listing-form"
    >
      <el-form-item label="排课课程: ">
        <el-input v-model="listingForm.courseName" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="班级名称: ">
        <el-input v-model="listingForm.className" :disabled="true"></el-input>
      </el-form-item>
      <p class="mwow-yellow" style="font-size: 12px; margin: 0 0 12px 75px">
        每一个多课程都有一个固定补课班
      </p>
      <el-form-item label="授课教师:" prop="teacher_ids">
        <el-select
          v-model="listingForm.teacher_ids"
          multiple
          style="display: none"
        ></el-select>
        <div class="mwow-common-form-multi-select">
          <div class="input-wrap">
            <p class="text">
              已添加<span class="mwow-green">{{
                listingForm.teacher_list.length
              }}</span
              >人
            </p>
            <all-teacher-selector
              :origin-data="listingForm.teacher_list"
              @change="handleTeacherSelect"
              :single="false"
            >
              <el-button class="mwow-button success">添加</el-button>
            </all-teacher-selector>
          </div>
          <div class="show-wrap" v-show="listingForm.teacher_list.length > 0">
            <span
              v-for="item in listingForm.teacher_list"
              :key="item.teacher_id"
              >{{ item.name }}</span
            >
          </div>
        </div>
      </el-form-item>
      <el-form-item label="授课模式: " prop="lesson_type">
        <el-radio-group v-model="listingForm.lesson_type">
          <el-radio-button :label="1">线下 - 门店授课</el-radio-button>
          <el-radio-button :label="2">线上 - 直播授课</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-row v-if="listingForm.lesson_type === 1">
        <el-col :span="20">
          <el-form-item label="上课教室:">
            <el-select
              v-model="listingForm.classroom_id"
              filterable
              clearable
              placeholder="请选择"
              :filter-method="handleSearchClassRoom"
              @change="changeClassRoom"
            >
              <el-option
                v-for="item in searchClassRoomList"
                :key="item.classroom_id"
                :label="item.name"
                :value="item.classroom_id"
              >
              </el-option>
            </el-select>
            <div class="max-people" v-if="classRoomPeople !== 0">
              最多可容纳 {{ classRoomPeople }}人
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <div class="mwow-green add-class-room" @click="showAddClassRoom">
            新增
          </div>
        </el-col>
      </el-row>
      <el-form-item
        label="开播教师:"
        v-if="listingForm.lesson_type === 2"
        prop="main_teacher_id"
      >
        <el-select v-model="listingForm.main_teacher_id" placeholder="请选择">
          <el-option
            v-for="item in listingForm.teacher_list"
            :key="item.teacher_id"
            :label="item.name"
            :value="item.teacher_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上课日期:" prop="date">
        <el-date-picker
          v-model="listingForm.date"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="上课时间:" prop="start_time">
        <div class="p1">
          <el-input
            v-model="listingForm.start_time"
            style="display: none"
          ></el-input>
          <step-time-range-selector
            :originStart.sync="listingForm.start_time"
            :originEnd.sync="listingForm.end_time"
          ></step-time-range-selector>
          <time-step-selector
            :oriStart.sync="listingForm.start_time"
            :oriEnd.sync="listingForm.end_time"
          ></time-step-selector>
        </div>
      </el-form-item>
      <el-form-item label="补课学员: ">
        <el-input
          v-model="listingForm.student_name"
          :disabled="true"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="btns">
      <el-button class="mwow-button-filled mini" @click="closeDialog"
        >取消</el-button
      >
      <el-button class="mwow-button-filled success mini" @click="saveListing"
        >保存</el-button
      >
    </div>
    <!-- 新增教室抽屉 -->
    <el-drawer
      title="添加教室"
      :visible.sync="addClassRoomDrawerVisible"
      direction="rtl"
      :size="416"
      destroy-on-close
      append-to-body
    >
      <add-dialog
        :visible.sync="addClassRoomDrawerVisible"
        :edit-info="''"
        @addClassRoomId="classRoomAddId"
      ></add-dialog>
    </el-drawer>
    <!-- 冲突弹窗 -->
    <el-dialog
      title="提示"
      destroy-on-close
      :visible.sync="conflictDialogVisible"
      append-to-body
    >
      <conflict-dialog
        :conflictData="conflictDialogData"
        :visible.sync="conflictDialogVisible"
        @submit="conflictConfirm"
      ></conflict-dialog>
    </el-dialog>
  </div>
</template>
<script>
import {
  quickConflictCheckI,
  quickConflictCheckApi,
} from "@/api/classSchedule";
import conflictDialog from "@/view/teachManagement/classManagement/classDetail/log/conflictDialog.vue";
import timeStepSelector from "@/components/timeStepSelector.vue";
import allTeacherSelector from "@/view/teachManagement/classManagement/classList/allTeacherSelector.vue";
import stepTimeRangeSelector from "@/components/stepTimeRangeSelector.vue";
import { lessonRepairAddApi, lessonRepairAddInter } from "@/api/makeUpLessons";
import eventBus from "@/utils/bus";
import { classroomSelectListApi } from "@/api/classRoom";
import addDialog from "@/components/addClassRoomDialog.vue";

export default {
  components: {
    stepTimeRangeSelector,
    timeStepSelector,
    allTeacherSelector,
    addDialog,
    conflictDialog,
  },
  // @Prop() originTime!: { date: string; start: string; end: string };
  // @Prop() makeUpInfo!: any;
  props: ["originTime", "makeUpInfo"],
  data() {
    return {
      listingForm: {
        courseName: this.makeUpInfo.course.title,
        className: this.makeUpInfo.course.title + " - 补课班",
        teacher_ids: [],
        teacher_list: [],
        lesson_type: 1,
        date: this.originTime.date,
        start_time: this.originTime.start,
        end_time: this.originTime.end,
        student_name: this.makeUpInfo.student.name,
        main_teacher_id: "",
        student_id: this.makeUpInfo.student.student_id,
        lesson_id: this.makeUpInfo.lesson_id,
        classroom_id: "",
      },
      searchClassRoomList: [],
      classRoomPeople: 0, // 可容纳人数
      addClassRoomDrawerVisible: false,
      rules: {
        teacher_ids: [
          { required: true, message: "请选择授课教师", trigger: "change" },
        ],
        date: [
          { required: true, message: "请选择上课日期", trigger: "change" },
        ],
        start_time: [
          { required: true, message: "请选择上课开始时间", trigger: "change" },
        ],
        end_time: [
          { required: true, message: "请选择上课结束时间", trigger: "change" },
        ],
        main_teacher_id: [
          { required: true, message: "请选择开播教师", trigger: "change" },
        ],
      },
      conflictDialogVisible: false,
      conflictDialogData: {},
    };
  },
  created() {
    this.handleSearchClassRoom("");
    eventBus.$on("initClassRoomManagement", () => {
      this.handleSearchClassRoom("");
    });
  },
  beforeDestroy() {
    eventBus.$off("initClassRoomManagement");
  },
  methods: {
    showAddClassRoom() {
      this.addClassRoomDrawerVisible = true;
    },
    classRoomAddId(id) {
      this.listingForm.classroom_id = id;
      this.changeClassRoom(this.listingForm.classroom_id);
    },
    handleSearchClassRoom(v) {
      classroomSelectListApi({
        page: 1,
        page_size: 1000,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.searchClassRoomList = res.data.list;
          this.changeClassRoom(this.listingForm.classroom_id);
        }
      });
    },
    changeClassRoom(i) {
      if (!this.listingForm.classroom_id) {
        this.classRoomPeople = 0;
      }
      this.searchClassRoomList.map((item) => {
        if (item.classroom_id === i) {
          this.classRoomPeople = item.people;
        }
      });
    },
    closeDialog() {
      this.$emit("update:visible", false);
    },
    handleTeacherSelect(arr) {
      this.listingForm.teacher_list = arr;
      const ids = arr.map((item) => {
        return item.teacher_id;
      });
      this.listingForm.teacher_ids = ids;
      if (!ids.includes(this.listingForm.main_teacher_id)) {
        this.listingForm.main_teacher_id = ids[0];
      }
    },
    saveListing() {
      this.$refs["listingForm"].validate((valid) => {
        if (valid) {
          this.handleConflictCheck();
        }
      });
    },
    handleConflictCheck() {
      const stime = this.listingForm.start_time.slice(0, 5) + ":00";
      const etime = this.listingForm.end_time.slice(0, 5) + ":00";
      const params = {
        teacher_ids: this.listingForm.teacher_ids,
        student_ids: [this.listingForm.student_id],
        start_time: stime,
        end_time: etime,
        date: this.listingForm.date,
      };
      if (this.listingForm.classroom_id) {
        params.classroom_id = this.listingForm.classroom_id;
      }
      quickConflictCheckApi(params).then((res) => {
        if (res.error_code === 0) {
          if (res.data.conflict) {
            res.data.current_list.map((item) => {
              item.class.name = this.listingForm.className;
            });
            this.conflictDialogVisible = true;
            this.conflictDialogData = res.data;
          } else {
            this.conflictConfirm();
          }
        }
      });
    },
    conflictConfirm() {
      const params = { ...this.listingForm };
      const option = {
        student_id: params.student_id,
        relation_lesson_id: params.lesson_id,
        teacher_ids: params.teacher_ids,
        main_teacher_id: params.main_teacher_id,
        lesson_type: params.lesson_type,
        start_time: params.start_time + ":00",
        end_time: params.end_time + ":00",
        date: params.date,
      };
      if (this.listingForm.classroom_id) {
        option.classroom_id = Number(this.listingForm.classroom_id);
      }
      lessonRepairAddApi(option).then((res) => {
        if (res.error_code === 0) {
          this.$message({
            type: "success",
            message: "补课排课完成",
          });
          this.$router.go(-1);
        }
        this.$emit("change");
        this.closeDialog();
      });
    },
  },
};
</script>
<style scoped lang="scss">
.addDialog {
  background-color: #ffffff;
  border-radius: 4px;
  .listing-form {
    flex: 1;
    padding: 20px 0 20px 20px;
    margin-right: 80px;
    /deep/ .el-select {
      width: 100% !important;
      .el-input {
        width: 100% !important;
      }
    }
  }
  .btns {
    position: absolute;
    bottom: 10px;
    right: 10px;
    padding: 20px;
    text-align: right;
  }
  .p1 {
    display: flex;
  }
}
</style>
